const shimmer = {
  animation: "route-skeleton-shimmer 1.2s ease-in-out infinite alternate",
  background: "linear-gradient(90deg, #eef2f7 0%, #f7f9fc 50%, #eef2f7 100%)",
  backgroundSize: "200% 100%",
};

const block = (width, height, radius = 10) => ({
  ...shimmer,
  width,
  height,
  borderRadius: radius,
});

const RouteSkeleton = () => (
  <main style={styles.wrap} aria-busy="true" aria-live="polite">
    <style>{`
      @keyframes route-skeleton-shimmer {
        0% { background-position: 0% 50%; opacity: 0.9; }
        100% { background-position: 100% 50%; opacity: 1; }
      }
    `}</style>

    <div style={styles.container}>
      <div style={block("38%", 18)} />
      <div style={{ ...block("72%", 46, 14), marginTop: 14 }} />
      <div style={{ ...block("92%", 20), marginTop: 20 }} />
      <div style={{ ...block("84%", 20), marginTop: 12 }} />

      <div style={styles.grid}>
        <div style={styles.card}>
          <div style={block("65%", 18)} />
          <div style={{ ...block("100%", 12), marginTop: 14 }} />
          <div style={{ ...block("92%", 12), marginTop: 10 }} />
          <div style={{ ...block("70%", 12), marginTop: 10 }} />
        </div>
        <div style={styles.card}>
          <div style={block("58%", 18)} />
          <div style={{ ...block("100%", 12), marginTop: 14 }} />
          <div style={{ ...block("88%", 12), marginTop: 10 }} />
          <div style={{ ...block("64%", 12), marginTop: 10 }} />
        </div>
        <div style={styles.card}>
          <div style={block("70%", 18)} />
          <div style={{ ...block("100%", 12), marginTop: 14 }} />
          <div style={{ ...block("90%", 12), marginTop: 10 }} />
          <div style={{ ...block("66%", 12), marginTop: 10 }} />
        </div>
      </div>
    </div>
  </main>
);

const styles = {
  wrap: {
    minHeight: "56vh",
    padding: "20px 14px 28px",
    background: "#f8fafc",
  },
  container: {
    maxWidth: 1120,
    margin: "0 auto",
    background: "#ffffff",
    border: "1px solid #e4e8ef",
    borderRadius: 16,
    padding: 18,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 14,
    marginTop: 20,
  },
  card: {
    border: "1px solid #e9edf4",
    borderRadius: 12,
    padding: 14,
  },
};

export default RouteSkeleton;
